<div class="title-sub-table bold">
    Dispositif
</div>
<mat-progress-bar mode="indeterminate" color="accent" *ngIf="loading">
</mat-progress-bar>

<div *ngFor="let schedule of schedules; let i=index" [ngClass]="{'loading': loading}">
    <app-advertising-package-details [schedule]="schedule" [purchaseProgram]="purchaseProgram">
    </app-advertising-package-details>
</div>